<template>
  <transition-group name="fade-slide-out" mode="out-in">
    <div
      class="region-message"
      v-for="(message, index) in currentMessages"
      :key="index"
    >
      <p>{{ message }}</p>
      <button class="delete-button" @click="hideMessage(index)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="10"
          height="10"
          viewBox="0 0 30 30"
          style="pointer-events: none"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </button>
    </div>
  </transition-group>
</template>
<script>
import { ref, onMounted, onUnmounted, getCurrentInstance } from "vue";

export default {
  name: "Alerts",

  setup() {
    const currentMessages = ref([]);
    const timerDuration = ref(5000);

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const hideMessage = (index) => {
      currentMessages.value.splice(index, 1);
    };
    const emitDynamicMessage = (message) => {
      currentMessages.value.push(message);

      setTimeout(() => {
        currentMessages.value.shift();
      }, timerDuration.value);
    };
    emitter.on("dynamicMessage", emitDynamicMessage);

    onMounted(() => {
      onUnmounted(() => {
        emitter.off("dynamicMessage", emitDynamicMessage);
      });
    });

    return {
      currentMessages,
      hideMessage,
    };
  },
};
</script>

<style>
.fade-slide-out-enter-active,
.fade-slide-out-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.fade-slide-out-enter,
.fade-slide-out-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.region-message {
  border: 1px solid #ccc;
  margin-bottom: 10px;
  padding: 10px;
}
</style>
